import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
interface Props {
  children: ReactNode;
  locale: string;
}
const Html = t0 => {
  const $ = _c(3);
  const {
    children,
    locale
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== locale) {
    t1 = <html lang={locale} className="h-full">{children}</html>;
    $[0] = children;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Html;